export default __webpack_public_path__ + "static/media/logoWhite.2c5da6d7.png";